import { action } from 'typesafe-actions';
import { ActionTypes, TAuth } from './types';

// export const getUserR = () => action(ActionTypes.GET_USER_R);
// export const getUserS = (payload: TUser) => action(ActionTypes.GET_USER_S, payload);
// export const getUserE = (message: string) => action(ActionTypes.GET_USER_E, message);

export const setAuth = (payload: boolean) => action(ActionTypes.SET_IS_AUTH, payload);
export const setUser = (payload: TAuth | null) => action(ActionTypes.SET_USER, payload);
